import { captureException, startSpan } from "@sentry/react";

import { FilterFieldDTO, IArtStylesResponse } from "../../types";
import { doGet } from "../core/http";

export const getThemes = async (): Promise<any> => {
    try {
        const { data, error } = await startSpan({ name: "getThemes" }, () => {
            return doGet("/theme/all", false);
        });

        if (error) {
            captureException(error);
            return { error };
        }

        return {
            themes: data || [],
        };
    } catch (e) {
        captureException(e);
        return { error: "Failed to get themes" };
    }
};

export const getFields = async (): Promise<any> => {
    try {
        const { data, error } = await startSpan({ name: "getFields" }, () => {
            return doGet("/v1/npc/fields", false);
        });

        if (error) {
            captureException(error);
            return { error };
        }

        return {
            fields: data || [],
        };
    } catch (e) {
        captureException(e);
        return { error: "Failed to get fields" };
    }
};

export const getFieldsForEntity = async (entityName: string): Promise<any> => {
    try {
        const { data, error } = await startSpan(
            { name: "getFieldsForEntity" },
            () => {
                return doGet(`/theme/${entityName}`, false);
            }
        );

        if (error) {
            captureException(error);
            return { error };
        }

        return {
            fields: data || [],
        };
    } catch (e) {
        captureException(e);
        return { error: "Failed to get fields" };
    }
};

export const getMonsterFields = async (): Promise<any> => {
    try {
        const { data, error } = await startSpan(
            { name: "getMonsterFields" },
            () => {
                return doGet("/v1/monster/fields", false);
            }
        );

        if (error) {
            console.error(error); // Use console.error as in original
            return { error };
        }

        return {
            fields: data || [],
        };
    } catch (e) {
        console.error(e); // Use console.error as in original
        return { error: "Failed to get fields" };
    }
};

export const getFilterFields = async (): Promise<FilterFieldDTO[]> => {
    try {
        const url = "/api/v1/search/filters";
        const { data, error } = await startSpan(
            { name: "getFilterFields" },
            () => {
                return doGet(url, false);
            }
        );

        if (error) {
            captureException(error);
            return [];
        }

        return data;
    } catch (e) {
        captureException(e);
        return [];
    }
};

export const getArtStyles = async (): Promise<IArtStylesResponse> => {
    try {
        const url = "/theme/art-styles";
        const { data, error } = await startSpan(
            { name: "getArtStyles" },
            () => {
                return doGet(url, false);
            }
        );

        if (error) {
            captureException(error);
            return {
                artStyles: [],
            };
        }

        return data;
    } catch (e) {
        captureException(e);
        return {
            artStyles: [],
        };
    }
};
